import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import CssBaseline from '@material-ui/core/CssBaseline';

import { createStore, StoreProvider } from '../store';
import { apolloClient } from '../apollo-client';
import { FeatureFlagProvider } from '../feature-flags';
import { StaffSpeedDial } from './speed-dial';
import { StaffToolsChat } from './staff-tools-chat';
import { AppcuesLaunchpadDrag } from './appcues-launchpad-drag';
import Auth from './auth';
import ErrorBoundary from './error-boundary';
import Layout from './layout/layout';
import Routes from './routes';
import ThemeProvider from './theme';
import { Toast, ToastProvider } from './toast';

const store = createStore(apolloClient);
const App = () => {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <StoreProvider store={store}>
          <ToastProvider>
            <Auth client={apolloClient}>
              <FeatureFlagProvider>
                <ApolloProvider client={apolloClient}>
                  <CssBaseline />

                  <Router basename="/">
                    <Layout>
                      <Routes />
                    </Layout>
                    <StaffSpeedDial quotePage={false} />
                    <StaffToolsChat />
                    <AppcuesLaunchpadDrag />
                  </Router>
                  <Toast />
                </ApolloProvider>
              </FeatureFlagProvider>
            </Auth>
          </ToastProvider>
        </StoreProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default App;
